import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hstack gap-1 h-100" }

import Vue from "vue";
import {defineComponent, ref, watch} from "vue";
import type {PropType} from "vue";
import Multiselect from "@vueform/multiselect";
import {BFieldSelection} from "../BFilterEditor/BFilterEditor.types";


export default /*@__PURE__*/_defineComponent({
  __name: 'ListField',
  props: {
    items: {},
    disabled: { type: Boolean },
    modelValue: {},
    label: {},
    ariaLabel: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

var select = ref<any | null>(null);

const props = __props;

const emit = __emit;

function handleUpdate(event: any) {
    if (select.value != null) {
        select.value.focus();
    }
    emit("update:modelValue", event);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "label", {}, () => [
      _createTextVNode(_toDisplayString(__props.label), 1)
    ]),
    _createVNode(_unref(Multiselect), {
      ref_key: "select",
      ref: select,
      "model-value": __props.modelValue,
      options: __props.items,
      mode: "single",
      "close-on-select": true,
      label: 'text',
      searchable: true,
      "filter-results": true,
      strict: false,
      submit: false,
      "native-support": true,
      aria: { 'aria-label': __props.ariaLabel },
      classes: {
                tag: 'bg-secondary text-white text-sm py-0.5 pl-2 rounded mr-1 mb-1 flex items-center tagwidth-100 text-truncate rtl:pl-0 rtl:pr-2 rtl:mr-0 rtl:ml-1',
            },
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (handleUpdate($event)))
    }, null, 8, ["model-value", "options", "aria"])
  ]))
}
}

})